import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { constants } from '../../constants'
import optionsMessages from '../../components/helpers/options-messages'
import ModalMessage from './ModalMessage'


const NewMessage = (props) => {
  const toggle = props.toggleSidebar ? '215px' : '10px'
  const [reminders, setReminders] = useState([]);
  const [congratulations, setCongratulations] = useState([]);
  const [offers, setOffers] = useState([]);
  const [idMessage, setIdMessage] = useState(0);
  const [typeMessage, setTypeMessage] = useState('');
  const [renderModalMesage, setRenderModalMessage] = useState(false);

  const getDefaultMessage = async() => {
    const URL = constants.test_host + '/sms/default-messages'
    const {data} = await axios.get(URL, {headers: {'Content-Type': 'application/json'}})
    setReminders(data.defaultMessages.reminders);
    setCongratulations(data.defaultMessages.congratulations);
    setOffers(data.defaultMessages.offers);
  }

  const selectItem = (target, type_message) => {
    setIdMessage(target.id);
    setTypeMessage(type_message);
    setRenderModalMessage(true);
  }

  
  const tableReminder = reminders.map((item) =>

    <tr key={item[0]}>
      <td>{item[0]}</td>
      <td style={{textAlign: 'justify'}}>{item[1] ? item[1] : ''}<span className={item[2] ? item[2]+ ' spanEdit' : '' }>{item[2] ? optionsMessages[item[2]][0] : ''}</span>{item[3] ? item[3] : ''}<span className={item[4] ? item[4]+ ' spanEdit' : ''}>{item[4] ? optionsMessages[item[4]][0] : ''}</span>{item[5] ? item[5] : ''}</td>
      <td><a  id={item[0]}  onClick={(e) => selectItem(e.target, 'reminders')} className='btn btn-primary btn-sm' href="#messageModal" role="button" data-bs-toggle="modal">Select</a></td>
    </tr>
  )
  const tableCongratulation = congratulations.map((item) =>

    <tr key={item[0]}>
      <td>{item[0]}</td>
      <td style={{textAlign: 'justify'}}>{item[1] ? item[1] : ''}<span className={item[2] ? item[2]+ ' spanEdit' : '' }>{item[2] ? optionsMessages[item[2]][0] : ''}</span>{item[3] ? item[3] : ''}<span className={item[4] ? item[4]+ ' spanEdit' : ''}>{item[4] ? optionsMessages[item[4]][0] : ''}</span>{item[5] ? item[5] : ''}</td>
      <td><a  id={item[0]}  onClick={(e) => selectItem(e.target, 'congratulations')} className='btn btn-primary btn-sm' href="#messageModal" role="button" data-bs-toggle="modal">Select</a></td>
    </tr>
  )
  const tableOffer = offers.map((item) =>

    <tr key={item[0]}>
      <td>{item[0]}</td>
      <td style={{textAlign: 'justify'}}>{item[1] ? item[1] : ''}<span className={item[2] ? item[2]+ ' spanEdit' : '' }>{item[2] ? optionsMessages[item[2]][0] : ''}</span>{item[3] ? item[3] : ''}<span className={item[4] ? item[4]+ ' spanEdit' : ''}>{item[4] ? optionsMessages[item[4]][0] : ''}</span>{item[5] ? item[5] : ''}</td>
      <td><a  id={item[0]}  onClick={(e) => selectItem(e.target, 'offers')} className='btn btn-primary btn-sm' href="#messageModal" role="button" data-bs-toggle="modal">Select</a></td>
    </tr>
  )

  useEffect(() => {
    getDefaultMessage();
  }, []);


  return (
    <div className="content-wrapper content" style={{ marginLeft: `${toggle}`, transition: "all 0.5s" }} >
      <h5>Mensajes predeterminados:</h5>
      <p style={{fontSize: '14px'}}>Seleciona el mensaje que desees enviar, las palabras subrayadas puedes editarlas deacuerdo a tus necesidades pulsando el botón edit.</p>
      <div>
        <h6 style={{textAlign: 'left', paddingLeft:'20px'}}>Recordatorios:</h6>
        <table className="table table-striped" style={{marginLeft: '15px', fontSize:'smaller'}}>
          <thead>
            <tr>
              <th>#Id</th>
              <th>Mensaje</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {tableReminder}
          </tbody>
        </table>
      </div>
      <div>
        <h6 style={{textAlign: 'left', paddingLeft:'20px'}}>Felicitaciones:</h6>
        <table className="table table-striped" style={{marginLeft: '15px', fontSize:'smaller'}}>
          <thead>
            <tr>
              <th>#Id</th>
              <th>Mensaje</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {tableCongratulation}
          </tbody>
        </table>
      </div>
      <div>
        <h6 style={{textAlign: 'left', paddingLeft:'20px'}}>Ofertas:</h6>
        <table className="table table-striped" style={{marginLeft: '15px', fontSize:'smaller'}}>
          <thead>
            <tr>
              <th>#Id</th>
              <th>Mensaje</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {tableOffer}
          </tbody>
        </table>
      </div>
  
      <div id="messageModal" className="modal fade" tabIndex="-1">
        <div className="modal-dialog">
          <div className='modal-content font-mulish'>
            {renderModalMesage && <ModalMessage id= {idMessage} setIdMessage={setIdMessage} typeMessage={typeMessage} start= {props.start} />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewMessage
